/**
 * ---   平台信息配置   ---
 *
 * code 平台代码
 * name  中文名称
 * nameEn  英文名称
 * smallLogo 平台小图
 * largeLogo 平台大图
 *
 */

const platformList = [
  {
    code: "TEMU",
    name: "拼多多跨境(半托管)",
    nameEn: "TEMU半托管",
    smallLogo:
      "//oss.dianleida.net/1688-web/images/platform_logos/pdd-logo.png",
    largeLogo:
      "//oss.dianleida.net/1688-web/images/platform_logos/logos-large-pdd.png",
    icon: "",
  },
  {
    code: "TEMU_FULLY",
    name: "拼多多跨境(全托管)",
    nameEn: "TEMU全托管",
    smallLogo:
      "//oss.dianleida.net/1688-web/images/platform_logos/pdd-logo.png",
    largeLogo:
      "//oss.dianleida.net/1688-web/images/platform_logos/logos-large-pdd-2.png",
    icon: "",
  },
  {
    code: "1688",
    name: "1688",
    nameEn: "1688",
    smallLogo:
      "//oss.dianleida.net/1688-web/images/platform_logos/1688-logo.png",
    largeLogo:
      "//oss.dianleida.net/1688-web/images/platform_logos/logos-large-pdd-2.png",
    icon: "",
  },
];
export default platformList;
